import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'
import t from '~/scopes/campaign/data/metals/silicon.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['gomez2023', 'ademe2024'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['ademe2024'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['greenIt'],
  },
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['ademe2024', 'pblEnvironmental2024'],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['ademe2024'],
        },
        {
          title: SECTIONS.environmentalSoil,
          text: t.envSoilText,
          sourceRefs: ['pblEnvironmental2024'],
        },
        {
          title: SECTIONS.environmentalClimate,
          text: t.envClimateText,
          sourceRefs: ['ademe2024', 'pblEnvironmental2024'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['ademe2024', 'chenSilica2012'],
      },
      blocks: [
        {
          title: SECTIONS.humanWaterRights,
          text: t.humanWaterText,
          sourceRefs: ['ademe2024'],
        },
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['chenSilica2012'],
        },
        {
          title: SECTIONS.humanLegal,
          text: t.humanLegalText,
          sourceRefs: ['pblEnvironmental2024', 'chenSilica2012'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'ademe2024'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['ademe2024'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['ademe2024'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['ieaGcmo2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['greenIt'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['ieaMineralsExplorer'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['ademe2024'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['ademe2024', 'jrcCircular2017'],
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: ['ademe2024', 'ieaRecycling2024'],
      },
    ],
  },
  footnotes: [
    {
      slots: ['countries'],
      body: [
        {
          text: t.footnote1Text1,
        },
        {
          text: t.footnote1Text2,
        },
      ],
    },
    {
      slots: ['environmentalScore'],
      body: [
        {
          text: t.footnote2Text1,
        },
      ],
    },
  ],
  mine0Region: t.mine0Region,
  mine1Region: t.mine1Region,
  mine2Region: t.mine2Region,
  mine3Region: t.mine3Region,
  mine4Region: t.mine4Region,
} as const
